import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../components/Loader';
import { FormField, FormFields } from '../../../components/FormFields';
import { BaseComponent } from '../../../components/BaseComponent';
import { Button } from '../../../components/Buttons';
import { Check, IsClosed, Reset, EditSquare, Times, Waiting } from '../../../components/Icon';
import { selectIbanCheckResult, selectNewCompanyValue } from '../selectors';
import { selectWork } from '../../Api/selectors';
import { REQUEST_COMPANY, REQUEST_IBAN_CHECK } from '../constants';
import { Input } from '../../../components/Input';
import { Modal, ModalControls } from '../../../components/Modal';
import { SetBVIDone } from '../../KanbanBoards/cells/BVI/SetBVIDone';
import { HBox, VBox } from '../../../components/Box';
import { checkIban, setNewCompanyValue, updateCompanyProperties } from '../actions';
import { Checkbox } from '../../../components/Checkbox';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';
import styles from './IbanField.module.css';

const ContainerApproved = styled.div`
  background-color: white;
  color: rgb(21, 172, 121);
  padding: 3px;
`;
const ContainerNotApproved = styled.div`
  color: red;
  padding: 3px;
  background-color: white;
`;
const FontNotApproved = styled.div`
  color: red;
`;

const STATE = {
  ibanModal: false,
  value: null,
  valueChanged: false,
  showConfirmResult: false,
  applySuggestedName: false,
  approveManual: false,
};

/* eslint-disable react/prefer-stateless-function */
class IbanFieldComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  get ibanType() {
    return this.props.type == 'IBAN2' ? 'IBAN2' : 'IBAN';
  }

  reset() {
    this.setState({ ...STATE });
  }

  onClickCloseIbanModal() {
    this.setState({ ibanModal: false });
  }

  onClickIbanModal() {
    this.setState({ ibanModal: true });
  }

  onChangeIbanValue(evt) {
    this.setState({ value: evt.target.value, valueChanged: true, approveManual: false });
  }

  onChangeApproveManualValue() {
    this.setState(prev => {
      return { approveManual: !prev?.approveManual };
    });
  }

  onConfirmIban() {
    const name = this.props.name ?? '';
    const iban = this.ibanValue ?? '';
    this.setState({ showConfirmResult: true }, () => {
      this.props.ibanCheck(name, iban);
    });
  }

  onSave() {
    const IBAN_approved = !!this.props?.ibanCheckResult?.ibanResult || this.state.approveManual ? '1' : '0';
    const props = [
      { name: this.ibanType, value: this.ibanValue?.replace(/\s/g, '') },
      { name: `${this.ibanType}_approved`, value: IBAN_approved },
    ];
    if (this.state.approveManual) {
      props.push({ name: `${this.ibanType}_approved_manual`, value: '1' });
    } else {
      props.push({ name: `${this.ibanType}_approved_manual`, value: '0' });
    }
    if (
      !this.props?.ibanCheckResult?.nameResult &&
      this.props?.ibanCheckResult?.correctName &&
      this.state.applySuggestedName
    ) {
      props.push({ name: 'name', value: this.props?.ibanCheckResult?.correctName });
      const { name, surname } = this.divideFullName();
      if (name) props.push({ name: 'name', value: name });
      if (surname) props.push({ name: 'surname', value: surname });
    }
    // TODO added since these props is being reseted after moving to next step. Remove when will be solved
    for (let prop of props) {
      this.props.setValue(prop['value'], prop['name']);
    }

    if (!this.props.kanbanPage) {
      this.props.updateCompanyProperties(props);
      for (let prop of props) {
        this.props.reset(prop['name']);
      }
    }

    if (this.props.incomingInvoice || this.props.kanbanPage) {
      this.props.setIban(this.ibanValue, this.state.approveManual);
      this.setState({ ibanModal: false });
    }
  }

  divideFullName() {
    if (this.props?.company_type === 'individual') {
      const parts = this.props?.ibanCheckResult?.correctName.split(' ');
      const name = parts.shift();
      const surname = parts.join(' ');

      return {
        name,
        surname: surname ? surname : undefined,
      };
    }
    return { name: this.props?.ibanCheckResult?.correctName };
  }

  ibanResultLabel() {
    if (!this.props?.ibanCheckResult?.ibanResult) {
      return (
        <ContainerNotApproved>
          <Times />
        </ContainerNotApproved>
      );
    }

    return (
      <ContainerApproved>
        <Check />
      </ContainerApproved>
    );
  }

  nameResultLabel() {
    if (this.props?.ibanCheckResult?.nameError) {
      return (
        <FontNotApproved>
          <p>{this.props?.ibanCheckResult?.nameError}</p>
        </FontNotApproved>
      );
    }

    if (!this.props?.ibanCheckResult?.nameResult) {
      return (
        <ContainerNotApproved>
          <Times />
        </ContainerNotApproved>
      );
    }

    return (
      <ContainerApproved>
        <Check />
      </ContainerApproved>
    );
  }

  ibanResultValue() {
    let checkName = this.props?.ibanCheckResult?.nameError || !this.props?.ibanCheckResult?.nameResult ? false : true;
    let checkIban = !this.props?.ibanCheckResult?.ibanResult ? false : true;

    return checkName && checkIban;
  }

  toggleApplySuggestedName() {
    this.setState((prev, props) => {
      return { ...prev, applySuggestedName: !prev.applySuggestedName };
    });
  }

  suggestedNameRow() {
    return (
      this.props?.ibanCheckResult?.correctName &&
      !this.props?.ibanCheckResult?.nameResult && (
        <VBox>
          <p>Suggested name</p>
          <p>{this.props?.ibanCheckResult?.correctName}</p>
          <Checkbox checked={this.state.applySuggestedName} onChange={this.toggleApplySuggestedName.bind(this)}>
            {this.lbl(`company.iban.applyName`)}
          </Checkbox>
        </VBox>
      )
    );
  }

  renderIbanCheckResult() {
    if (!this.state.showConfirmResult) return '';
    if (this.props.workIBanCheck) return <Loader small />;
    return (
      <VBox>
        <HBox>
          <p>Iban</p>
          {this.ibanResultLabel()}
        </HBox>
        <HBox>
          <p>Name</p>
          {this.nameResultLabel()}
        </HBox>
        {this.suggestedNameRow()}
      </VBox>
    );
  }

  renderIbanModal() {
    return (
      this.state.ibanModal && (
        <ModalComponent onClose={this.onClickCloseIbanModal.bind(this)} title={this.lbl('close')}>
          <label className="form-label">{this.lbl('company.iban.newIbanValue')}</label>
          <input
            className="form-control"
            value={this.ibanValue || ''}
            onChange={this.onChangeIbanValue.bind(this)}
            name="value"
          />
          <div className="mt-2">
            <CheckboxComponent
              label={this.lbl('company.iban.approve_manual')}
              checked={this.state.approveManual}
              onChange={this.onChangeApproveManualValue.bind(this)}
            />
          </div>

          {this.renderIbanCheckResult()}

          <div className="mt-2 d-flex gap-2">
            {this.props.work ? (
              <Loader small />
            ) : (
              <>
                <ButtonComponent style="ButtonSoftEdit" onClick={this.onSave.bind(this)}>
                  {this.lbl('save')}
                </ButtonComponent>
                <ButtonComponent
                  style="ButtonSoftDelete"
                  disabled={this.state.approveManual}
                  onClick={this.onConfirmIban.bind(this)}
                >
                  {this.lbl('company.iban.checkIban')}
                </ButtonComponent>
              </>
            )}
          </div>
        </ModalComponent>
      )
    );
  }

  get ibanValue() {
    return this.state.valueChanged ? this.state.value : this.originIbanValue;
  }

  get originIbanValue() {
    if (this.props.incomingInvoice || this.props.kanbanPage) {
      return this.props.value;
    }
    if (this.props.company?.[this.ibanType] && typeof this.props.company?.[this.ibanType] === 'string') {
      return this.props.company?.[this.ibanType]?.replaceAll(' ', '');
    }
    return this.props.company?.[this.ibanType];
  }

  get ibanStatusDecorator() {
    if (this.props.kanbanPage) {
      return this.state.approveManual ? (
        <ContainerApproved>
          <Check />
        </ContainerApproved>
      ) : this.ibanResultValue() && this.props.ibanApprovedManual != '1' ? (
        <ContainerApproved>
          <Check />
        </ContainerApproved>
      ) : this.props.ibanApprovedManual == '1' ? (
        <ContainerApproved>
          <Check />
        </ContainerApproved>
      ) : (
        <ContainerNotApproved>
          <Times />
        </ContainerNotApproved>
      );
    }
    if (this.props.company?.[`${this.ibanType}_approved`] && this.props.company?.[`${this.ibanType}_approved`] === '1') {
      return (
        <ContainerApproved>
          <Check />
        </ContainerApproved>
      );
    }

    return (
      <ContainerNotApproved>
        <Times />
      </ContainerNotApproved>
    );
  }

  render() {
    return (
      <>
        <Input
          mediumwide="true"
          style={this.props.cardWidth}
          value={this.originIbanValue || ''}
          disabled={true}
          onChange={this.props.onChange}
          name="value"
          className={styles.containerButton}
          leftDecoration={this.ibanStatusDecorator}
          rightDecoration={
            <Button className={styles.button} small={this.props.small} onClick={this.onClickIbanModal.bind(this)}>
              <EditSquare />
            </Button>
          }
        />
        {this.renderIbanModal()}
      </>
    );
  }
}

IbanFieldComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_COMPANY),
    workIBanCheck: selectWork(`${REQUEST_IBAN_CHECK}-${ownProps.company?.id}`),
    name: selectNewCompanyValue('fullname'),
    company_type: selectNewCompanyValue('company_type'),
    ibanCheckResult: selectIbanCheckResult(ownProps.company?.id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    updateCompanyProperties(props) {
      const id = ownProps.company?.id;
      dispatch(updateCompanyProperties(id, props));
    },
    ibanCheck(name, iban) {
      const id = ownProps.company?.id;
      dispatch(checkIban(id, name, iban));
    },
    setValue(value, name = null) {
      dispatch(setNewCompanyValue(name, value));
    },
    reset(name) {
      dispatch(setNewCompanyValue(name, ''));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const IbanField = compose(withConnect, withRouter)(IbanFieldComp);
